import {Box, styled} from "@mui/material";
import WrapperCalendar from "../../../components/calendar";
import Notify from "../../../components/notify";
import {useEffect, useState} from "react";
import {fetchAllRaccolte} from "../../../features/operator";
import {RaccoltaCalendarEvent} from "../../../types";
import {parseRaccoltaCalendarEvents, scale} from "../../../utils";
import theme from "../../../constants/theme";

const Wrapper = styled(Box)({
  marginTop: scale(34),
  [theme.breakpoints.down('sm')]: {
    marginTop: 0,
  },
});

const CalendarioOperatore = () => {
  const [showNotify, setShowNotify] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [raccolte, setRaccolte] = useState<RaccoltaCalendarEvent[]>([]);

  useEffect(() => {
    if (sessionStorage.getItem('successCreation') === 'true') {
      setShowNotify(true);
      sessionStorage.removeItem('successCreation');
    }
    fetchAllRaccolte().then((res) => {
      const parsedEvents = parseRaccoltaCalendarEvents(res);
      setRaccolte(parsedEvents);
    }).catch(err => {
      console.error(err);
    }).finally(() => setIsLoading(true))
  }, []);

  if (!isLoading) {
    return null
  }

  return (
    <Wrapper>
      <Notify show={showNotify} />
      <WrapperCalendar events={raccolte}/>
    </Wrapper>
  );
};

export default CalendarioOperatore;
